export default __webpack_public_path__ + "static/media/ico-foot-facebook.9d0af8a2.svg";